import { Locale, translate } from "./translations";

const ja: Locale = {
  welcome: "APAATOへようこそ",
  signIn: "サインイン",
  register: "登録",
  accountType: "アカウント種別",
  accountTypeUser: "ユーザー",
  accountTypePartner: "パートナー",
  firstName: "名",
  lastName: "姓",
  orgName: "組織名",
  createAccount: "アカウント作成",
  registrationRequired: "続行するには登録を完了してください。",
  signOut: "サインアウト",
  greeting: (name: string) => `こんにちは、${name}`,
  email: "メールアドレス",
  password: "パスワード",
  continueWithGoogle: "Googleで続行",
  pleaseWait: "お待ちください...",
  fillAllFields: "すべての項目を入力してください。",
  userNotFound: "このメールアドレスのユーザーは見つかりませんでした。",
  wrongPassword: "パスワードが正しくありません。",
  authFailed: "認証に失敗しました。もう一度お試しください。",
  signInCancelled: "サインイン処理がキャンセルされました。",
  googleSignInFailed:
    "Googleでのサインインに失敗しました。もう一度お試しください。",
  notAuthorized: "この環境へのアクセスは許可されていません。",
  registrationFailed: "登録に失敗しました。もう一度お試しください。",

  confirmPassword: "パスワード（確認）",
  accountTypeUserHint: "日本で部屋を探したい",
  accountTypePartnerHint: "住宅の広告を掲載したい",
  show: "表示",
  hide: "非表示",
  emailRequired: "メールアドレスは必須です",
  emailInvalid: "正しいメールアドレスを入力してください",
  passwordRequired: "パスワードは必須です",
  passwordMin8: "パスワードは8文字以上にしてください",
  passwordNeedNumber: "パスワードに数字を1つ以上含めてください",
  passwordNeedSymbol: "パスワードに記号を1つ以上含めてください",
  passwordNeedUpper: "パスワードに大文字を1つ以上含めてください",
  passwordNeedLower: "パスワードに小文字を1つ以上含めてください",

  passwordRequirements: "パスワード要件",
  passwordReqMin8: "8文字以上",
  passwordReqNumber: "数字を1つ以上",
  passwordReqSymbol: "記号を1つ以上",
  passwordReqUpper: "大文字を1つ以上",
  passwordReqLower: "小文字を1つ以上",

  notVerified: "メールを確認してからサインインしてください。",
  forbidden: "この環境へのアクセスは許可されていません。",

  confirmPasswordRequired: "パスワードを再入力してください",
  passwordsDontMatch: "パスワードが一致しません",
  firstNameRequired: "名は必須です",
  lastNameRequired: "姓は必須です",
  orgNameRequired: "組織名は必須です",

  // Email verification flow
  verificationSentTitle: "メールを確認してください",
  verificationSentBody: (email: string) =>
    `${email}に確認メールを送信しました。受信箱を確認し、リンクをクリックしてアカウントを認証してください。`,
  okGotIt: "了解",
  emailConfirmedTitle: "メール認証完了",
  emailConfirmedBody:
    "ありがとうございます！メールが認証されました。アカウントにログインできます。",
  logIntoAccount: "ログイン",

  // Verification page
  verificationFailedTitle: "認証に失敗しました",
  verificationExpired:
    "この認証リンクは有効期限が切れています。新しいリンクをリクエストしてください。",
  verificationInvalid: "この認証リンクは無効か、既に使用されています。",
  verificationFailed:
    "メールの認証ができませんでした。後でもう一度お試しください。",
  verificationMissingCodeTitle: "認証コードがありません",
  verificationMissingCodeBody:
    "認証コードが提供されていません。メールのリンクをもう一度クリックしてください。",
  backToLogin: "サインインに戻る",
  resendVerificationEmail: "認証メールを再送信",
  resendVerificationHint: (email: string) =>
    `${email}に新しい認証リンクを送信しますか？`,
  verificationResent:
    "新しい認証メールを送信しました。受信箱をご確認ください。",
  resendFailed: "認証メールの送信に失敗しました。もう一度お試しください。",

  // Homepage
  dashboard: "ダッシュボード",
  homeHeroTitle: "日本で理想の住まいを見つけよう",
  homeHeroSubtitle:
    "東京の厳選されたアパートメントを、外国人居住者にも日本人にも。",
  searchPrefecture: "都道府県",
  searchSelectPrefecture: "都道府県を選択",
  searchCity: "市区町村",
  searchSelectCity: "市区町村を選択",
  searchLocation: "エリア",
  searchSelectArea: "エリアを選択",
  searchMoveIn: "入居日",
  searchMoveInPlaceholder: "日付を選択",
  searchOccupants: "入居者数",
  searchRentBudget: "月額予算",
  searchRoomLayout: "間取り",
  searchPerson: "名",
  searchPeople: "名",
  searchButton: "物件を検索",
  searchEditCriteria: "検索条件を編集",
  featureQualityTitle: "品質保証",
  featureQualityDesc: "すべての物件は品質と快適さが確認されています。",
  featureTrustedTitle: "信頼のパートナー",
  featureTrustedDesc: "認定された不動産会社やオーナーと提携。",
  featureSupportTitle: "現地サポート",
  featureSupportDesc: "多言語対応のチームが新生活をサポート。",
  disclaimerTitle: "MVP開発中",
  disclaimerBody:
    "これは初期MVPバージョンです。検索機能と物件一覧は近日公開予定です。現在は東京エリアのみサポートされます。",
  footerRights: "All rights reserved.",

  // Philosophy Section
  philosophyTitle: "私たちの理念",
  philosophySubtitle:
    "外国人の方が日本でアパートを探すプロセスをシンプルにしたいと考えています。",
  philosophyNoFeesTitle: "隠れた費用なし",
  philosophyNoFeesDesc:
    "完全な価格透明性。表示された価格がお支払い金額です — 驚きはありません。",
  philosophySimpleTitle: "シンプルなインターフェース",
  philosophySimpleDesc:
    "次の住まいを簡単に見つけられる、クリーンで直感的なデザイン。",
  philosophyQualityTitle: "高品質な物件情報",
  philosophyQualityDesc:
    "物件とアパートに関するすべての必要な詳細を備えた高品質な物件一覧。",
  philosophyVerifiedTitle: "認証済み不動産会社",
  philosophyVerifiedDesc:
    "信頼できる認証済みの不動産プロフェッショナルのみと提携。",

  // Snackbar messages
  welcomeUserSnackbar: "ようこそ！ダッシュボード機能は近日公開予定です。",
  welcomeAdminSnackbar: "おかえりなさい、管理者さん！",

  // Dashboard
  dashboardWelcome: "おかえりなさい",
  dashboardSubtitle: "お部屋探しと保存した物件を管理できます。",
  dashboardSearch: "検索",
  dashboardSearchDesc: "東京の物件を探す",
  dashboardFavorites: "お気に入り",
  dashboardFavoritesDesc: "保存した物件を見る",
  dashboardNotifications: "通知",
  dashboardNotificationsDesc: "検索の更新情報",
  dashboardSettings: "設定",
  dashboardSettingsDesc: "アカウントを管理",
  dashboardComingSoon: "機能開発中",
  dashboardComingSoonDesc: "これらの機能は現在開発中です。近日公開予定です！",
  dashboardDevTools: "開発者ツール",
  dashboardDevToolsDesc: "テストと開発用のAPIアクセス",
  dashboardTokenInfo: "IDトークンを使用してAPIリクエストを認証します：",
  dashboardShowToken: "トークンを表示",
  dashboardCopyToken: "トークンをコピー",
  dashboardCopied: "コピーしました！",
  dashboardTokenError:
    "トークンを取得できませんでした。ページを更新してください。",

  // Overview Page
  back: "戻る",
  overviewSearchingIn: "検索中",
  overviewListView: "リスト",
  overviewMapView: "地図",
  overviewResultsTitle: "検索結果",
  overviewNoResults: "0件の物件が見つかりました",
  overviewEmptyTitle: "物件が見つかりませんでした",
  overviewEmptyDesc:
    "フィルターや検索条件を調整して、より多くの物件を見つけてください。データは近日追加予定です。",
  overviewMapTitle: "地図表示",
  overviewMapComingSoon: "地図表示は近日公開",
  overviewMapComingSoonDesc:
    "物件の位置を示すインタラクティブマップは今後のアップデートで利用可能になります。",
  overviewLoading: "物件を検索中...",
  overviewResults: "件の物件が見つかりました",
  overviewErrorTitle: "エラーが発生しました",
  overviewRetry: "再試行",
  overviewLoadingMore: "読み込み中...",
  overviewLoadMore: "もっと見る",

  // Listing Card
  "listings.min": "分",
  "listings.month": "月",
  "listings.foreignerFriendly": "外国人可",
  "listings.petsAllowed": "ペット可",
  "listings.airConditioning": "AC",
  "listings.deposit": "敷金",
  "listings.keyMoney": "礼金",

  // Filters
  filtersTitle: "フィルター",
  filterReset: "リセット",

  // Filter Categories
  filterCategoryProperty: "物件タイプ",
  filterCategoryPrice: "価格・費用",
  filterCategorySize: "広さ・間取り",
  filterCategoryAmenities: "設備",
  filterCategoryBuilding: "建物",
  filterCategoryAccess: "アクセス",
  filterCategoryContract: "契約条件",

  // Property Types
  filterPropertyType: "物件タイプ",
  filterPropertyApartment: "アパート",
  filterPropertyMansion: "マンション",
  filterPropertyShareHouse: "シェアハウス",
  filterPropertyGuestHouse: "ゲストハウス",
  filterPropertyMonthlyMansion: "マンスリーマンション",

  // Room Layouts
  filterRoomLayout: "間取り",
  filterLayout1R: "1R",
  filterLayout1K: "1K",
  filterLayout1DK: "1DK",
  filterLayout1LDK: "1LDK",
  filterLayout2K: "2K",
  filterLayout2DK: "2DK",
  filterLayout2LDK: "2LDK",
  filterLayout3K: "3K",
  filterLayout3DK: "3DK",
  filterLayout3LDKPlus: "3LDK以上",

  // Price Filters
  filterMinRent: "最低家賃",
  filterMaxRent: "最高家賃",
  filterIncludeManagementFee: "管理費込み",
  filterKeyMoney: "礼金",
  filterDeposit: "敷金",
  filterGuarantor: "保証人",
  filterNoKeyMoney: "礼金なし",
  filterNoDeposit: "敷金なし",
  filterHalfMonth: "0.5ヶ月",
  filter1Month: "1ヶ月",
  filter2Months: "2ヶ月",
  filterAny: "指定なし",
  filterYes: "必要",
  filterNo: "不要",

  // Size Filters
  filterMinSize: "最小面積",
  filterMaxSize: "最大面積",

  // Amenities
  filterAirConditioning: "エアコン",
  filterWasherHookup: "洗濯機置場",
  filterWasherDryerInUnit: "洗濯乾燥機付き",
  filterBathToiletSeparate: "バス・トイレ別",
  filterBalcony: "バルコニー",
  filterFlooringWood: "フローリング",
  filterInternetIncluded: "インターネット込み",
  filterGasStove: "ガスコンロ",
  filterIHCooktop: "IHコンロ",

  // Building
  filterBuildingAge: "築年数",
  filterAnyAge: "指定なし",
  filterUnder5Years: "築5年以内",
  filterUnder10Years: "築10年以内",
  filterUnder20Years: "築20年以内",
  filterUnder30Years: "築30年以内",
  filterFloor: "階数",
  filterAnyFloor: "指定なし",
  filterFirstFloor: "1階",
  filter2ndFloorPlus: "2階以上",
  filter3rdFloorPlus: "3階以上",
  filterTopFloor: "最上階",
  filterElevator: "エレベーター",
  filterAutoLock: "オートロック",
  filterDeliveryBox: "宅配ボックス",
  filterParking: "駐車場あり",
  filterBicycleParking: "駐輪場",

  // Access
  filterWalkToStation: "駅徒歩",
  filterAnyWalkTime: "指定なし",
  filterWithin5Min: "5分以内",
  filterWithin10Min: "10分以内",
  filterWithin15Min: "15分以内",
  filterWithin20Min: "20分以内",

  // New categories
  filterCategoryBathroom: "バス・洗濯",
  filterCategoryKitchen: "キッチン",
  filterCategorySecurity: "セキュリティ",
  filterCategoryListing: "掲載",

  // Bathroom & Laundry
  filterIndoorWasherSpace: "室内洗濯機置場",
  filterReheatingBath: "追い焚き",
  filterBathroomDryer: "浴室乾燥機",
  filterWashletSeat: "温水洗浄便座",
  filterIndependentVanity: "独立洗面台",

  // Kitchen
  filterSystemKitchen: "システムキッチン",
  filterCounterKitchen: "カウンターキッチン",
  filterDishwasher: "食器洗い機",

  // Building extras
  filterSouthFacing: "南向き",
  filterCornerUnit: "角部屋",
  filterBuildingStructure: "構造",
  filterStructureRC: "鉄筋コンクリート",
  filterStructureSteel: "鉄骨造",
  filterStructureWood: "木造",
  filterStructureSRC: "鉄骨鉄筋コンクリート",

  // Security
  filterSecurityCamera: "防犯カメラ",
  filterVideoIntercom: "TVモニタ付インターホン",

  // Parking extras
  filterMotorcycleParking: "バイク置場",

  // Contract
  filterForeignerFriendly: "外国籍OK",
  filterPetsAllowed: "ペット可",
  filterInstrumentsOK: "楽器相談可",
  filterSohoOK: "事務所利用可",
  filterNoGuarantorNeeded: "保証人不要",
  filterMoveInWithin30Days: "即入居可",

  // Listing freshness
  filterListingFreshness: "掲載期間",
  filterFreshnessAny: "指定なし",
  filterFreshness24h: "24時間以内",
  filterFreshness3d: "3日以内",
  filterFreshness7d: "7日以内",
  filterFreshness14d: "14日以内",

  // Theme switcher
  themeSwitchToLight: "ライトモードに切り替え",
  themeSwitchToDark: "ダークモードに切り替え",

  // Partner type
  partnerType: "パートナー種別",
  partnerTypeIndividual: "個人",
  partnerTypeIndividualHint: "独立して活動しています",
  partnerTypeOrganization: "法人",
  partnerTypeOrganizationHint: "会社に所属しています",

  // Profile Page
  profileWelcome: "おかえりなさい",
  profileSubtitle: "プロフィール、物件、設定を管理できます。",
  profileSearch: "検索",
  profileSearchDesc: "東京の物件を探す",
  profileMyListings: "マイ物件",
  profileMyListingsDesc: "掲載中の物件を管理",
  profileFavorites: "お気に入り",
  profileFavoritesDesc: "保存した物件を見る",
  profileNotifications: "通知",
  profileNotificationsDesc: "アカウントの更新情報",
  profileSettings: "設定",
  profileSettingsDesc: "アカウントを管理",
  profileComingSoon: "機能開発中",
  profileComingSoonDesc: "お気に入り、通知、設定機能は現在開発中です。",
  profileCreateListing: "新規掲載",
  profileIndividual: "個人パートナー",
  backToProfile: "プロフィールに戻る",

  // Create/Edit Listing Page
  createListingTitle: "新規物件を掲載",
  editListingTitle: "物件を編集",
  createListingSubtitle: "物件情報を入力して掲載してください",
  createListingPartnerOnly: "パートナーのみ物件を掲載できます",
  createListingBasicInfo: "基本情報",
  createListingTitleField: "物件タイトル",
  createListingTitlePlaceholder: "例：渋谷駅近くの広々1LDK",
  createListingDescription: "物件説明",
  createListingDescPlaceholder:
    "物件の特徴、設備、周辺環境などを記載してください...",
  createListingLocation: "所在地",
  createListingCityPlaceholder: "例：東京都",
  createListingWard: "区",
  createListingAddress: "住所",
  createListingStation: "最寄り駅",
  createListingStationPlaceholder: "例：渋谷駅",
  createListingWalkMinutes: "駅徒歩（分）",
  createListingPricing: "料金",
  createListingPrice: "月額家賃（円）",
  createListingManagementFee: "管理費（円）",
  createListingBuilding: "建物情報",
  createListingArea: "面積（㎡）",
  createListingTotalFloors: "総階数",
  createListingYearBuilt: "築年",
  createListingAvailableFrom: "入居可能日",
  createListingPhotos: "写真",
  createListingPhotosHelp:
    "各セクションの写真をアップロードしてください。公開には最低5枚の画像が必要です。",
  createListingPhotosComingSoon: "写真アップロードは近日対応予定",
  createListingImageUploadError: "画像のアップロードに失敗しました",
  createListingSaveDraft: "下書き保存",
  createListingPublish: "公開する",
  createListingSaved: "下書きとして保存しました",
  createListingPublished: "物件を公開しました",
  createListingError: "物件の掲載に失敗しました。もう一度お試しください。",
  createListingValidationError: "必須項目を入力してください",
  validationErrors: "以下のエラーを修正してください：",
  createListingTitleRequired: "タイトルは必須です",
  createListingTitleMinLength: "タイトルは5文字以上にしてください",
  createListingPropertyTypeRequired: "物件タイプは必須です",
  createListingRoomLayoutRequired: "間取りは必須です",
  createListingPrefectureRequired: "都道府県は必須です",
  createListingCityRequired: "市区町村は必須です",
  createListingPriceRequired: "家賃は0円より大きい必要があります",
  createListingMinImagesRequired: "公開には最低5枚の画像が必要です",
  createListingAddressHint:
    "建物名、部屋番号を含む完全な住所を入力してください。",
  createListingInvalidAddress: "無効な住所です",
  createListingAddressValidationError: "住所の検証中にエラーが発生しました",
  createListingValidatingAddress: "住所を検証しています...",
  createListingValidating: "検証中...",
  createListingValidate: "住所を検証",

  // My Listings Page
  myListingsTitle: "マイ物件",
  myListingsSubtitle: "掲載中・下書きの物件を管理",
  myListingsPublishedTab: "公開中・履歴",
  myListingsDraftsTab: "下書き",
  myListingsEmpty: "物件がありません",
  myListingsEmptyDesc: "最初の物件を掲載してみましょう",
  myListingsEmptyPublished: "公開中の物件はありません",
  myListingsEmptyPublishedDesc:
    "下書きを公開するか、新しい物件を作成してください。",
  myListingsEmptyDrafts: "下書きの物件はありません",
  myListingsEmptyDraftsDesc:
    "すべての物件が公開されています。新しい物件を作成してください。",
  myListingsCreateFirst: "最初の物件を掲載",
  myListingsPublished: "公開中",
  myListingsDraft: "下書き",
  myListingsExpired: "非公開",
  myListingsEdit: "編集",
  myListingsDelete: "削除",
  myListingsDeleteTitle: "物件を削除",
  myListingsDeleteMessage:
    "この物件を削除してもよろしいですか？この操作は元に戻せません。",
  myListingsDeleteConfirm: "削除",
  myListingsDeleted: "物件を削除しました",
  myListingsDeleteError: "物件の削除に失敗しました",
  myListingsLoadError: "物件の読み込みに失敗しました",
  myListingsUnpublish: "非公開にする",
  myListingsRepublish: "再公開",
  myListingsPublishAction: "公開する",
  myListingsStatusUpdated: "物件のステータスを更新しました",
  myListingsStatusUpdateError: "物件のステータス更新に失敗しました",

  // Settings Page
  settingsTitle: "設定",
  settingsSubtitle: "アカウント設定と環境設定を管理",
  settingsProfilePicture: "プロフィール画像",
  settingsPhotoComingSoon: "写真アップロードは近日対応予定",
  settingsPersonalInfo: "個人情報",
  settingsPhone: "電話番号",
  settingsEmailReadOnly: "メールアドレスは変更できません",
  settingsOrganization: "組織",
  settingsOrgReadOnly: "組織を変更するにはサポートにお問い合わせください",
  settingsSecurity: "セキュリティ",
  settingsChangePasswordDesc:
    "現在のパスワードと新しいパスワードを入力してパスワードを変更できます",
  settingsCurrentPassword: "現在のパスワード",
  settingsNewPassword: "新しいパスワード",
  settingsChangePassword: "パスワードを変更",
  settingsPasswordChanged: "パスワードを変更しました",
  settingsCurrentPasswordWrong: "現在のパスワードが正しくありません",
  settingsPasswordTooWeak: "新しいパスワードが弱すぎます",
  settingsReauthRequired:
    "パスワードを変更する前に、一度サインアウトしてサインインし直してください",
  settingsPasswordChangeError:
    "パスワードの変更に失敗しました。もう一度お試しください。",
  settingsSave: "変更を保存",
  settingsSaved: "設定を保存しました",
  settingsSaveError: "設定の保存に失敗しました。もう一度お試しください。",
  settingsLoadError: "設定の読み込みに失敗しました",

  // Reset Password Page
  resetPasswordTitle: "パスワードをリセット",
  resetPasswordSubtitle: "アカウントの新しいパスワードを入力してください：",
  resetPasswordNewPassword: "新しいパスワード",
  resetPasswordSuccessTitle: "パスワードリセット完了",
  resetPasswordSuccessBody:
    "パスワードが正常に変更されました。新しいパスワードでログインできます。",
  resetPasswordMissingCodeTitle: "リセットコードがありません",
  resetPasswordMissingCodeBody:
    "リセットコードが提供されていません。パスワードリセットメールのリンクをクリックしてください。",
  resetPasswordFailedTitle: "パスワードリセットに失敗しました",
  resetPasswordExpired:
    "このパスワードリセットリンクは有効期限が切れています。ログインページから新しいリンクをリクエストしてください。",
  resetPasswordInvalid:
    "このパスワードリセットリンクは無効か、すでに使用されています。",
  resetPasswordFailed:
    "パスワードをリセットできませんでした。後でもう一度お試しください。",
  resetPasswordSubmit: "パスワードをリセット",

  // Verification System
  verificationVerified: "認証済み",
  verificationPending: "審査中",
  verificationUnverified: "未認証",
  verificationRejected: "却下されました",
  verificationModalTitle: "パートナー認証",
  verificationStep1: "登録情報",
  verificationStep2: "書類アップロード（KYB）",
  verificationAccountType: "アカウント種別",
  verificationAccountTypeCorporate: "法人（Hojin）",
  verificationAccountTypeIndividual: "個人（Kojin）",
  verificationAccountTypeHint:
    "登録時の情報から自動入力されます。法人は企業、個人は個人事業主用です。",
  verificationCompanyName: "正式な会社名",
  verificationCompanyNamePlaceholder: "例: 東京不動産株式会社",
  verificationCompanyNameHint:
    "会社またはビジネスの正式な法的名称を入力してください。",
  verificationLicenseNumber: "宅地建物取引業免許番号",
  verificationLicenseNumberHint:
    "フォーマット: [都道府県]知事 (X) 第XXXXX号（例: 東京都知事 (1) 第12345号）",
  verificationCorporateEmail: "法人メールアドレス",
  verificationCorporateEmailHint:
    "法人メールアドレスである必要があります。無料プロバイダー（Gmail、Yahooなど）は使用できません。",
  verificationOfficialWebsite: "公式ウェブサイト（任意）",
  verificationOfficialWebsiteHint:
    "認証目的のために、会社の公式ウェブサイトのURLを入力してください。",
  verificationAgencyLicense: "宅地建物取引業者免許証",
  verificationAgencyLicenseHint:
    "免許証の鮮明な写真またはスキャンをアップロードしてください。",
  verificationOfficerId: "宅地建物取引士証",
  verificationOfficerIdHint:
    "宅建士証のプラスチックカードの鮮明な写真をアップロードしてください。",
  verificationUploadComingSoon:
    "ファイルアップロードは近日公開予定です。メディアストレージの統合を待っています。",
  verificationDocumentNote:
    "メディアストレージが統合されたら、書類アップロード機能が利用できるようになります。今すぐフォームを送信して、後で書類をアップロードできます。",
  note: "注記",
  verificationStartButton: "認証を開始",
  verificationNext: "次のステップ",
  verificationBack: "戻る",
  verificationSubmit: "審査に提出",
  verificationThankYou: "ありがとうございます！",
  verificationThankYouMessage:
    "認証リクエストが正常に送信されました。当社のチームが申請を審査し、決定を通知いたします。通常1〜3営業日かかります。",
  verificationRequiredTooltip:
    "認証済みの不動産業者のみが物件を公開できます。認証を完了してください。",
  verificationRequiredMessage:
    "物件を作成する前に、アカウントが認証されている必要があります。プロフィールページから認証プロセスを完了してください。",
  verificationRequests: "認証リクエスト",
  verificationRequestsTitle: "パートナー認証リクエスト",
  verificationViewDetails: "詳細を見る",
  verificationApprove: "承認",
  verificationReject: "却下",
  verificationRejectionReason: "却下理由",
  verificationRejectionReasonPlaceholder:
    "例: 免許証のスキャンがぼやけています、より鮮明な画像で再提出してください",
  verificationSubmitted: "認証リクエストが正常に送信されました",
  verificationSubmitError: "認証リクエストの送信に失敗しました",

  // Forgot Password Flow (on Login Page)
  forgotPassword: "パスワードをお忘れですか？",
  resetPasswordDesc:
    "メールアドレスを入力してください。パスワードリセットリンクをお送りします。",
  resetPasswordSent:
    "そのメールアドレスでアカウントが存在する場合、リセットリンクを送信しました。受信トレイをご確認ください。",
  sendResetLink: "リセットリンクを送信",
  enterYourEmail: "メールアドレスを入力",

  // Layout Descriptions (for tooltips)
  layoutDescription1R:
    "キッチンスペース付きのワンルーム（独立したキッチンなし）",
  layoutDescription1K: "1部屋＋独立したキッチン",
  layoutDescription1DK: "1部屋＋ダイニングキッチン（8畳以上）",
  layoutDescription1LDK: "1部屋＋リビングダイニングキッチン（10畳以上）",
  layoutDescription2K: "2部屋＋独立したキッチン",
  layoutDescription2DK: "2部屋＋ダイニングキッチン",
  layoutDescription2LDK: "2部屋＋リビングダイニングキッチン",
  layoutDescription3K: "3部屋＋独立したキッチン",
  layoutDescription3DK: "3部屋＋ダイニングキッチン",
  layoutDescription3LDKPlus: "3部屋以上＋リビングダイニングキッチン",

  // Photo Sections
  photoSectionFloorPlan: "間取り図",
  photoSectionMainRoom: "メインルーム",
  photoSectionKitchenArea: "キッチンエリア",
  photoSectionBathroom: "浴室・トイレ",
  photoSectionGenkan: "玄関",
  photoSectionBedroom: "寝室",
  photoSectionKitchen: "キッチン",
  photoSectionDiningKitchen: "ダイニングキッチン",
  photoSectionLivingRoom: "リビングルーム",
  photoSectionRoom1: "部屋1",
  photoSectionRoom2: "部屋2",
  photoSectionRoom3: "部屋3",
  photoSectionRoom3Plus: "追加の部屋",
  photoUploadHint: "写真をドラッグ＆ドロップまたはクリックして選択",
  photoUploadMax: "1セクションあたり最大10枚",

  // FileUpload Component
  fileUploadDragDrop: "ファイルをドラッグ＆ドロップするか、クリックして選択",
  fileUploadClick: "クリックしてアップロード",
  fileUploadUploading: "アップロード中...",
  fileUploadError: "アップロードに失敗しました",
  fileUploadInvalidType: "無効なファイル形式です",
  fileUploadTooLarge: "ファイルサイズが大きすぎます",
  fileUploadMaxFiles: "最大{max}ファイルまで許可されています",

  // PhotoGalleryCarousel Component
  photoGalleryScrollLeft: "カテゴリを左にスクロール",
  photoGalleryScrollRight: "カテゴリを右にスクロール",
  photoGalleryPreviousPhoto: "前の写真",
  photoGalleryNextPhoto: "次の写真",
  photoGalleryNoImages: "このセクションには画像がありません",

  // Nearest Station Selector
  "listing.nearestStation.searching": "近くの駅を検索中...",
  "listing.nearestStation.fetchError": "近くの駅の読み込みに失敗しました",
  "listing.nearestStation.searchError": "駅の検索に失敗しました",
  "listing.nearestStation.invalidAddress":
    "無効な住所です。正しい日本の住所を入力してください。",
  "listing.nearestStation.suggested": "最寄り駅を選択してください：",
  "listing.nearestStation.selected": "選択された駅",
  "listing.nearestStation.minWalk": "分",
  "listing.nearestStation.notYourStations": "別の駅をお探しですか？手動で検索",
  "listing.nearestStation.autoSearch": "最寄り駅を検索",
  "listing.nearestStation.manualSelect": "駅を検索",
  "listing.nearestStation.searchPlaceholder": "駅名を入力...",
  "listing.nearestStation.noResults": "駅が見つかりません",
  "listing.nearestStation.tryAgain": "もう一度検索",
  "listing.nearestStation.enterAddress": "住所を入力して最寄り駅を検索",

  // Find Nearby Stations
  findNearbyStations: "最寄り駅を検索",

  // Common
  cancel: "キャンセル",
  "common.close": "閉じる",
  "common.search": "検索",
  "common.loading": "読み込み中...",
  "common.loadError": "データの読み込みに失敗しました",
  "common.noResults": "結果が見つかりません",

  // Location Dropdown
  "listing.location.selectPrefecture": "都道府県を選択",
  "listing.location.selectCity": "市区町村を選択",
  "listing.location.selectWard": "区/地域を選択",
  "listing.location.selectPrefectureFirst": "先に都道府県を選択してください",
  "listing.location.selectCityFirst": "先に市区町村を選択してください",
  "listing.nearestStation.minCharsError": "2文字以上入力してください",
  "listing.nearestStation.loading": "駅を読み込み中...",
  "listing.nearestStation.selectCityFirst": "まず都市を選択してください",
  "listing.nearestStation.waitForGeocoding":
    "住所の位置情報を取得中です。しばらくしてからもう一度お試しください",
  "listing.location.noDataAvailable": "データがありません",

  // Legal Documents
  termsOfUse: "利用規約",
  partnerTerms: "パートナー利用規約",
  privacyPolicy: "プライバシーポリシー",
  tokushoHo: "特定商取引法に基づく表記",
  iAgreeToThe: "以下に同意します：",
  termsAcceptanceRequired: "利用規約への同意が必要です",
  privacyAcceptanceRequired: "プライバシーポリシーへの同意が必要です",
  legalAcceptanceRequired: "必要な法的文書への同意をお願いします",

  // Listing Detail Page (missing keys)
  listingDetailBackToSearch: "検索に戻る",
  listingDetailPropertyDetails: "物件詳細",
  listingDetailDescription: "説明",
  listingDetailAmenities: "設備・特徴",
  listingDetailLocation: "所在地",
  listingDetailNearbyStation: "最寄り駅",
  listingDetailListedBy: "掲載者",
  listingDetailContactAgent: "問い合わせ",
  listingDetailVerifiedPartner: "認証済みパートナー",
  listingDetailMonthShort: "月",
  listingDetailManagementFee: "管理費",
  listingDetailBuilt: "築",
  listingDetailRoomLayout: "間取り",
  listingDetailArea: "面積",
  listingDetailPricePerMonth: "/ 月",
  expandFullscreen: "フルスクリーン",
  listingDetailNearestStations: "最寄り駅",
  listingDetailMinWalk: "徒歩",
  listingDetailDeposit: "敷金",
  listingDetailKeyMoney: "礼金",
  listingDetailGuarantorRequired: "保証人",
  listingDetailYes: "必要",
  listingDetailNo: "不要",
  listingDetailNotSpecified: "未指定",
  listingDetailNotFound: "物件が見つかりません",
  listingDetailNotAvailable: "この物件は利用できないか、削除されました。",
  listingDetailGoBack: "戻る",
  listingDetailLoading: "読み込み中...",
  listingDetailStationWalk: "分",
  listingDetailStation: "駅",

  // Photo sections (for carousel display)
  detailPhotoExterior: "外観",
  detailPhotoInterior: "内装",
  detailPhotoKitchen: "キッチン",
  detailPhotoBathroom: "浴室",
  detailPhotoOther: "その他",

  // Listing Form - Missing Translations
  selectedStations: "選択された駅",
  createListingAreaRequired: "公開には面積（㎡）が必要です",
  createListingFloorRequired: "公開には階数が必要です",
  createListingTotalFloorsRequired: "公開には総階数が必要です",
  createListingYearBuiltRequired: "公開には築年が必要です",
  createListingFeaturedPhoto: "注目写真",
  createListingSetFeatured: "注目に設定",
  createListingRemoveFeatured: "注目を解除",
  createListingFeaturedPhotoHint:
    "概要カードに表示する写真を選択してください。選択しない場合は間取り図が表示されます。",
};

export const t = (key: keyof Locale, ...args: string[]) =>
  translate(ja, key, ...args);
